module.exports = __webpack_public_path__ + "img/8.4da9634a.webp";